// extracted by mini-css-extract-plugin
export default {"ReplyButton":"po_a bhs_wx bhs_jb bhs_xl bhs_i bhs_j bhs_q bhs_vt bhs_et bhs_so bhs_sp bhs_eg","ReplyButton__icon":"po_b bhs_rz"};